import React, { FunctionComponent } from 'react'
import { Icon } from 'molecules/Icon'

import { ICheckboxComponent } from './Checkbox-types'

import { cn } from 'ethcss'
import { checkboxStyles } from './Checkbox-styles'

const DEFAULT_CHECKBOX_ICON_SIZE = 18
const DEFAULT_CHECKBOX_ICONS = {
    checked: {
        type: 'checkbox_on',
        color: 'blue',
    },
    notChecked: {
        type: 'checkbox_off',
        color: 'cloud',
    },
}

export const Checkbox: FunctionComponent<ICheckboxComponent> = ({
    checked,
    onChange = () => {},
    size = DEFAULT_CHECKBOX_ICON_SIZE,
    checkedIcon = DEFAULT_CHECKBOX_ICONS.checked,
    notCheckedIcon = DEFAULT_CHECKBOX_ICONS.notChecked,
    checkboxWrapper = checkboxStyles.wrapper,
    children,
}) => {
    const onClickHandle = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        onChange(!checked, e)
    }

    const otherProps = checked ? checkedIcon : notCheckedIcon

    return (
        <div className={cn(checkboxWrapper)} onClick={onClickHandle}>
            <Icon onClick={() => {}} size={size} {...otherProps} />
            {children}
        </div>
    )
}
